const question3 = {
    'question': 'Jak długo trwa proces psychoterapii?',
    'answer': 'W zależności od nurtu terapeutycznego może być on krótkoterminowy lub długoterminowy. Długość trwania procesu terapeutycznego to bardzo indywidualna kwestia i wpływa na nią m.in. specyfika problemu z którym zgłasza się  pacjent czy ustalone cele psychoterapii. Średni okres trwania psychoterapii waha się od kilku miesięcy do kilku lat.',
}

export default question3;